import script from "./UserEditAccessData.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEditAccessData.vue?vue&type=script&setup=true&lang=js"

import "./UserEditAccessData.vue?vue&type=style&index=0&id=3b0fdc29&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0fdc29"]])

export default __exports__